import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getTaxRates } from '../api'
import { unwrapResult } from '@reduxjs/toolkit'
import { IServiceTax } from '../typings'
import { externalAppTimeoutError } from '@user/store/utilities/functions'

export const useGetTaxRatesOnMount = (
  canadianLocation?: boolean,
  taxCode?: string,
) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [taxRates, setTaxRates] = useState<IServiceTax[]>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getTaxRates())

        if (mounted) {
          if (getTaxRates.fulfilled.match(result)) {
            const rates = unwrapResult(result)
            setTaxRates(
              rates.items.filter(
                (item) =>
                  taxCode === item.name ||
                  item.canadianTaxRate === canadianLocation,
              ),
            )
            setStatus('success')
          } else {
            externalAppTimeoutError(result.payload)
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, canadianLocation, taxCode])

  return { taxRateStatus: status, taxRates }
}
